import { render } from "./CorporateSalesPage.vue?vue&type=template&id=9a53222a"
import script from "./CorporateSalesPage.vue?vue&type=script&lang=js"
export * from "./CorporateSalesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__